import { type IconName, iconSet } from '@/components/icons/PhosphorIcon/icons';

export function isPhosphorIconName(name?: string): name is IconName {
    return name !== undefined && iconSet.has(name);
}
